export default function handlePageTitle() {

    const pageTitle = document.querySelector('.page-title');

    // If there's no page-title element, stop here.
    if (!pageTitle) return;

    // If the browser isn't using a mouse, stop here.
    if (!matchMedia('(pointer:fine)').matches) return;

    const pageTitleBg = pageTitle.classList.contains('page-title--bg');

    if (pageTitleBg) {
        var pageTitleText = document.querySelector('.page-title h1');
        var pageTitleVideo = document.querySelector('.page-title video');

        document.addEventListener('mousemove', function(event) {
            var mouseY = event.clientY;
            var maxBlur = 5;
            var maxScale = 1.05;
            var videoBlur = maxBlur - (mouseY / window.innerHeight) * maxBlur;
            var textBlur = (mouseY / window.innerHeight) * maxBlur;
            var scale = 1 + (mouseY / window.innerHeight) * (maxScale - 1);

            pageTitleVideo.style.filter = 'blur(' + videoBlur + 'px)';
            pageTitleVideo.style.transform = 'scale(' + scale + ') translate(-50%, -50%)';

            pageTitleText.style.filter = 'blur(' + textBlur + 'px)';
            pageTitleText.style.transform = 'scale(' + scale + ')';
        });
    }

}
